module.exports = "/_next/static/images/ProcessingDeduplication@2x-1255dcbda3f2429832ef6b312eb78144.png";